const BimModels = () => {
  return <div className="flex-column gap-grid column-start w-100"></div>;
};

export default BimModels;
